import { render } from "./BtnIntegrar.vue?vue&type=template&id=2f21c39d"
import script from "./BtnIntegrar.vue?vue&type=script&lang=js"
export * from "./BtnIntegrar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__